// extracted by css-extract-rspack-plugin
export default {"componentTabHeaderContainer":"componentTabHeaderContainer-oyV_XT"};